function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.6 9.1l-7.8-7.8c-.5-.5-1.3-.5-1.8 0l-2 2-2-2c-.5-.5-1.3-.5-1.8 0L.4 9.1c-.5.5-.5 1.3 0 1.8l7.8 7.8c.3.3.6.4.9.4.3 0 .6-.1.9-.4l2-2 2 2c.3.3.6.4.9.4.3 0 .7-.1.9-.4l7.8-7.8c.5-.5.5-1.3 0-1.8zM9.1 16l-6-6 6-6 1.1 1.1-4 4c-.5.5-.5 1.3 0 1.8l4 4L9.1 16zM12 6.9l3.1 3.1-3.1 3.1L8.9 10 12 6.9zm2.9 9.1l-1.1-1.1 4-4c.5-.5.5-1.3 0-1.8l-4-4L14.9 4l6 6-6 6z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20"
  }, props), _ref);
};

export default SvgComponent;